import { ids } from '@icarros/theme-react';
import styled, { css } from 'styled-components';

interface ProposalsWrapperProps {
  isMessageOpen?: boolean;
  isTransition?: boolean;
  hasBanner?: boolean;
  isFixed?: boolean;
}

export const ProposalsContentWrapper = styled.div``;

export const ProposalsWrapper = styled.div<ProposalsWrapperProps>`
  display: flex;
  flex-direction: column;
  padding-block: 40px;
  gap: 32px;
  height: initial;
  min-height: 100vh;

  ${({ isFixed }) =>
    isFixed &&
    css`
      @media (min-width: 1440px) {
        position: sticky;
        top: 0;
        height: 100vh;
      }
    `}

  ${({ isMessageOpen, isTransition }) =>
    isMessageOpen &&
    !isTransition &&
    css`
      display: none;
      visibility: hidden;
    `}

  ${ProposalsContentWrapper} > button {
    align-self: center;
    margin-top: 24px;
  }

  ${ProposalsContentWrapper} > div:first-of-type {
    margin-bottom: 48px;
    max-width: 486px;
  }

  @media (min-width: 1366px) {
    padding-block-start: 24px !important;
    flex: 1;

    border-right: 1px solid ${ids.color.border.ids_color_border_soft};
    padding-inline-end: 72px !important;
    ${({ isMessageOpen }) =>
      isMessageOpen &&
      css`
        height: 100vh;
        position: sticky;
        top: 0;
        align-self: flex-start;
        overflow: hidden;
        display: block;
        visibility: visible;
      `}
  }

  ${({ hasBanner }) =>
    hasBanner &&
    css`
      justify-content: space-between;
      gap: 44px;
    `}
`;

export const ListItemModifier = styled.div`
  > div,
  > button {
    width: 100%;
  }
  > button {
    min-height: 84px;
    height: auto;
    padding-block: 12px;

    div:first-of-type {
      margin-left: 0;

      span:last-of-type {
        width: 140px;
        white-space: nowrap;
        overflow: hidden;
        text-overflow: ellipsis;

        @media (min-width: 360px) {
          width: 220px;
        }

        @media (min-width: 420px) {
          width: 300px;
        }

        @media (min-width: 460px) {
          width: 350px;
        }
      }
    }
    div:last-of-type {
      > span {
        width: 60px;
        text-align: right;
      }
    }
  }
  span {
    text-align: left;
  }

  &:last-of-type {
    > div {
      display: none;
    }
  }
`;
